<template>
  <div class="flex h-screen flex-col justify-between gap-10">
    val1 {{ val }}
    <div class="w-[600px]">
      <Selectbox
        v-model="val"
        :options="options"
        multiselect
        stringify
        placeholder="no chance"
      />
    </div>
    <Selectbox v-model="val2" placeholder="place" :options="options" />
    <Selectbox
      :width="120"
      v-model="val3"
      placeholder="rewr"
      :options="options2"
      clear
    />
    <Selectbox
      :width="420"
      v-model="val4"
      placeholder="cats"
      :options="options3"
      :option-height="80"
    />
    <Selectbox
      multiselect
      :width="420"
      v-model="val5"
      placeholder="cats"
      :options="options3"
      :option-height="80"
      tags
      clear
    />
  </div>
</template>
<script setup lang="ts">
  import { Selectbox } from '#components'

  const val = ref([''])
  const val2 = ref()
  const val3 = ref(1)
  const val4 = ref()
  const val5 = ref([])
  const options = [
    {
      title: 'АВЫАЫВАавыавыавыа',
      value: 23,
    },
    {
      title: 'eqwwqe',
      value: 12,
    },
    {
      title: 'АВЫАЫВ 13вы авыа dwfdf fdfweqrweq werrwerw ewrewr',
      value: 22,
    },
    {
      title: 'АВЫАЫВА213231авыавыавыа',
      value: 3,
    },
    {
      title: 'АВЫАЫВАа32213выавыавыа',
      value: 222,
    },
    {
      title: 'АВЫАЫВА213231авыавыавыа',
      value: 322,
    },
    {
      title: '2323',
      value: 333,
    },
    {
      title: '232',
      value: 2232,
    },
  ]

  const options2 = [
    {
      title: 'One',
      value: 1,
    },
    {
      title: 'Two',
      value: 2,
    },
  ]

  const options3 = [
    {
      title: 'One',
      value: 1,
      img: 'data:image/jpeg;base64,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',
    },
    {
      title: 'Two',
      value: 2,
      img: 'https://media.istockphoto.com/id/1067347086/ru/%D1%84%D0%BE%D1%82%D0%BE/%D0%BA%D0%BE%D1%88%D0%BA%D0%B0-%D1%81-%D0%B3%D0%BE%D0%BB%D1%83%D0%B1%D1%8B%D0%BC%D0%B8-%D0%B3%D0%BB%D0%B0%D0%B7%D0%B0%D0%BC%D0%B8-%D1%81%D0%BC%D0%BE%D1%82%D1%80%D0%B8%D1%82-%D0%B2-%D0%BA%D0%B0%D0%BC%D0%B5%D1%80%D1%83.jpg?s=612x612&w=0&k=20&c=YSgL1fPTLhuFeudKVos4dStwI4bFWRd_Yz3uupZzarU=',
    },
  ]
</script>
